import React from 'react';
import SignUpButton from '../sign-up-button';
import SignInButton from '../sign-in-button';

export default function UnregisteredNav() {
  return (
    <ul className="application-navbar-signed-out-controls">
      <li className="application-navbar-signed-out-controls-sign-up">
        <SignUpButton />
      </li>
      <li>
        <SignInButton />
      </li>
    </ul>
  );
}
